export const BAD_EVENT_NAME_PATTERNS = ['bulktest', 'bulk test', 'unknown event', 'test event'];

export const TIME_PERIOD_LABELS = {
  today: 'Today',
  this_week: 'This week',
  this_month: 'This month',
  all_time: 'All time',
  custom: 'Custom range',
};

export function isValidEventName(name) {
  if (!name) return false;
  const lower = name.toLowerCase();
  return !BAD_EVENT_NAME_PATTERNS.some((pattern) => lower.includes(pattern));
}

export function productTypeLabel(value) {
  if (!value || value === 'all') return 'All types';
  return String(value)
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function collectAvailableVenues(summaryData) {
  const seen = new Set();
  const venues = [];

  function addVenue(venue) {
    if (!venue) return;
    if (venue.venueId === null || venue.venueId === undefined) return;
    const venueName = venue.venueName || venue.name || '';
    if (!venueName || venueName === 'Unknown / Unassigned venue') return;

    const key = String(venue.venueId);
    if (seen.has(key)) return;
    seen.add(key);
    venues.push({ venueId: venue.venueId, venueName });
  }

  (summaryData?.topVenues || []).forEach(addVenue);
  Object.values(summaryData?.groupedByCurrency || {}).forEach((group) => {
    (group?.topVenues || []).forEach(addVenue);
  });

  return venues;
}
